"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUPPLIER = void 0;
var SUPPLIER = {
  INPUT__SEARCH: 'newPendingUpdate-input-search',
  BUTTON__SEARCH_RESULT: 'newPendingUpdate-button-searchResult',
  BUTTON__ORDER_DATE: 'newPendingUpdate-button-orderDate',
  NEW_SUPPLIER: {
    BUTTON__ADD_IMAGE: 'newPendingUpdateNewSupplier-button-addImage',
    BUTTON__REMOVE_IMAGE: 'newPendingUpdateNewSupplier-button-removeImage',
    INPUT__NAME: 'newPendingUpdateNewSupplier-input-name',
    INPUT__ADDITIONAL_INFO: 'newPendingUpdateNewSupplier-input-additionalInfo',
    BUTTON__CANCEL: 'newPendingUpdateNewSupplier-button-cancel',
    BUTTON__SAVE: 'newPendingUpdateNewSupplier-button-save'
  }
};
exports.SUPPLIER = SUPPLIER;